import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';

class ValidatedStateController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;

    static $inject = [];
}

export const wtValidatedState: ComponentDefinition = {
    componentId: 'wtValidatedState',
    controller: ValidatedStateController,
    template: require('./validatedState.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};